module.exports = __webpack_public_path__ + "img/icon-ny-1.e1458abe.svg";